import IService from "@api/iService";
import {GameProject} from "@interfaces/game";
import {PanelSettings} from "@interfaces/panel";

export default class DataService extends IService {

    async getPanelSettings(): Promise<PanelSettings> {
        return await this.getAndThrowApi<PanelSettings>(`/api/data/settings/`);
    }

    async getProject() {
        return await this.getApi<GameProject>('/api/data/project/');
    }
}